<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card :title="'保险登记'">
      <BaseForm ref="baseForm" @getVehicleInfo="setVehicleInfo"  @plateNumberChange="plateNumberChange"/>
      <RegistrationInfo
        ref="registrationInfoForm"
        v-if="$route.query.type !== 'detail'"
      />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import RegistrationInfo from './registrationInfo';
import SubBtnBox from 'components/subBtnBox';
import {
  getVehicleCertificatesInsurance,
  doSaveVehicleCertificatesInsurance,
} from 'api/car';
import pageDataMixin from '@qx/mixin/pageData';
import {normalizeObjectResponseData} from 'api/fileResponseCompat';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    RegistrationInfo,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/car/maintain/insurance/edit',
      formComponents: [
        'baseForm',
        'registrationInfoForm',
      ],
      editParams: {
        busiType: 1,
      },

      subLoading: false,
      // 需要对比的参数
      compareParams: {
        vehicle: {},

        insuranceStartDate: '',
        insuranceEndDate: '',
        insuranceTerminationDate: '',

        certificatesInsuranceFee: '',
        insuranceCompany: '',
        insuranceCode: '',
        insuranceInsurant: '',
        state: '',
        backInsuranceFee: '',
        serviceName: '',
        picList: [],
      },
    };
  },
  computed: {
    detailParams () {
      return {
        id: this.$route.query.id,
      };
    },
  },
  methods: {
    async detailApi (params) {
      const response = await getVehicleCertificatesInsurance(params);
      return normalizeObjectResponseData(response);
    },
    editApi: doSaveVehicleCertificatesInsurance,

    // 处理对比参数
    adjustCompareParams (compareParams) {
      if (Object.keys(compareParams.vehicle)) {
        compareParams.plateNumber = compareParams.vehicle.plateNumber;
      }
      compareParams.insuranceStartDate = this.formatDate(compareParams.insuranceStartDate);
      compareParams.insuranceEndDate = this.formatDate(compareParams.insuranceEndDate);
      compareParams.insuranceTerminationDate = this.formatDate(compareParams.insuranceTerminationDate);

      if (compareParams.picList.length) {
        compareParams.picFileIds = (compareParams.picList.map((item) => item.fileId)).join(',');
      } else {
        compareParams.picFileIds = '';
      }
    },
    setVehicleInfo (vehicleInfo) {
      this.$refs.registrationInfoForm.setVehicleInfo(vehicleInfo);
    },
    plateNumberChange (plateNumberInfo) {
      this.$refs.registrationInfoForm.setCertificatesInsuranceType(plateNumberInfo);

    },
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style>
</style>
